import { ColorMediaShape, CustomMediaShape } from "./media.types";
import { TemplateInteractableLogicProps } from "./logic.types";
import { Component } from "./component.types";

export const AlignmentJSWithOrder = [
  ["topleft", "Top Left"],
  ["topmiddle", "Top Middle"],
  ["topright", "Top Right"],
  ["centerleft", "Center Left"],
  ["centermiddle", "Center Middle"],
  ["centerright", "Center Right"],
  ["bottomleft", "Bottom Left"],
  ["bottommiddle", "Bottom Middle"],
  ["bottomright", "Bottom Right"],
];

export const AlignmentJS = Object.fromEntries(AlignmentJSWithOrder);

export type Alignment = keyof typeof AlignmentJS;

export const NavbarAlignmentJSWithOrder = [
  ["centerleft", "Center Left"],
  ["centermiddle", "Center Middle"],
  ["centerright", "Center Right"],
];

export const NavbarAlignmentJS = Object.fromEntries(NavbarAlignmentJSWithOrder);

export type NavbarAlignment = keyof typeof NavbarAlignmentJS;

export type BackgroundPosition = keyof typeof BackgroundPositionJS;

export const BackgroundPositionJSWithOrder = [
  ["bottom", "Bottom"],
  ["center", "Center"],
  ["left", "Left"],
  ["left-bottom", "Left Bottom"],
  ["left-top", "Left Top"],
  ["right", "Right"],
  ["right-bottom", "Right Bottom"],
  ["right-top", "Right Top"],
  ["top", "Top"],
];

export const BackgroundPositionJS = Object.fromEntries(
  BackgroundPositionJSWithOrder
);

export type BackgroundRepeat = keyof typeof BackgroundRepeatJS;

export const BackgroundRepeatJS = {
  repeat: "Repeat",
  ["no-repeat"]: "No Repeat",
};

export type BackgroundSize = keyof typeof BackgroundSizeJS;

export const BackgroundSizeJS = {
  auto: "Auto",
  cover: "Cover",
  contain: "Contain",
};

export const BackgroundAttachmentJSWithOrder = [
  ["fixed", "Fixed"],
  ["local", "Local"],
  ["scroll", "Scroll"],
];

export const BackgroundAttachmentJS = Object.fromEntries(
  BackgroundAttachmentJSWithOrder
);

export type BackgroundAttachment = keyof typeof BackgroundAttachmentJS;

export type SizeWithAuto = keyof typeof SizeWithAutoJS;

export const SizeWithJSWithOrder = [
  [0, "0"],
  [0.5, "0.5"],
  [1, "1"],
  [1.5, "1.5"],
  [2, "2"],
  [2.5, "2.5"],
  [3, "3"],
  [3.5, "3.5"],
  [4, "4"],
  [5, "5"],
  [6, "6"],
  [7, "7"],
  [8, "8"],
  [9, "9"],
  [10, "10"],
  [11, "11"],
  [12, "12"],
  [14, "14"],
  [16, "16"],
  [20, "20"],
  [24, "24"],
  [28, "28"],
  [32, "32"],
  [36, "36"],
  [40, "40"],
  [44, "44"],
  [48, "48"],
  [52, "52"],
  [56, "56"],
  [60, "60"],
  [64, "64"],
  [68, "68"],
  [72, "72"],
  [76, "76"],
  [80, "80"],
  [84, "84"],
  [88, "88"],
  [92, "94"],
  [96, "96"],
  [100, "100"],
  [104, "104"],
  [108, "108"],
  [112, "112"],
  [116, "116"],
  [120, "120"],
  [124, "124"],
  [128, "128"],
  [132, "132"],
  [134, "134"],
  [136, "136"],
  [140, "140"],
  [144, "144"],
  [148, "148"],
  [152, "152"],
  [156, "156"],
  [160, "160"],
  [164, "164"],
  [168, "168"],
  [172, "172"],
  [176, "176"],
  [180, "180"],
  [184, "184"],
  [188, "188"],
  [192, "192"],
  [196, "196"],
  [200, "200"],
  [204, "204"],
  [208, "208"],
  [212, "212"],
  [216, "216"],
  [220, "220"],
  [224, "224"],
  [228, "228"],
  [232, "232"],
  [236, "236"],
  [240, "240"],
  [244, "244"],
  [248, "248"],
  [252, "252"],
  [256, "256"],
  [260, "260"],
  [264, "264"],
  [268, "268"],
  [272, "272"],
  [276, "276"],
  [280, "280"],
  [284, "284"],
  [288, "288"],
  [292, "292"],
  [296, "296"],
  [300, "300"],
  [304, "304"],
  [308, "308"],
  [312, "312"],
  [316, "316"],
  [320, "320"],
  [324, "324"],
  [328, "328"],
  [332, "332"],
  [334, "334"],
  [336, "336"],
  [340, "340"],
  [344, "344"],
  [348, "348"],
  [352, "352"],
  [356, "356"],
  [360, "360"],
  [364, "364"],
  [368, "368"],
  [372, "372"],
  [376, "376"],
  [380, "380"],
  [384, "384"],
  [388, "388"],
  [392, "392"],
  [396, "396"],
  [400, "400"],
];

export const SizeJS = Object.fromEntries(SizeWithJSWithOrder);

export type Size = keyof typeof SizeJS;

export const WrapWithJSWithOrder = [
  ["wrap", "Wrap"],
  ["nowrap", "No Wrap"],
];

export const WrapJS = Object.fromEntries(WrapWithJSWithOrder);

export type Wrap = keyof typeof WrapJS;

export const SizeSmallWithJSWithOrder = [
  [0, "0"],
  [0.5, "0.5"],
  [1, "1"],
  [1.5, "1.5"],
  [2, "2"],
  [2.5, "2.5"],
  [3, "3"],
  [3.5, "3.5"],
  [4, "4"],
  [5, "5"],
  [6, "6"],
  [7, "7"],
  [8, "8"],
  [9, "9"],
  [10, "10"],
  [11, "11"],
  [12, "12"],
  [14, "14"],
  [16, "16"],
  [20, "20"],
  [24, "24"],
  [28, "28"],
  [32, "32"],
  [36, "36"],
  [40, "40"],
  [44, "44"],
  [48, "48"],
  [52, "52"],
  [56, "56"],
  [60, "60"],
  [64, "64"],
  [68, "68"],
];

export const SizeSmallJS = Object.fromEntries(SizeSmallWithJSWithOrder);

export type SizeSmall = keyof typeof SizeSmallJS;

export const SizeWithAutoJS = { ...SizeJS, auto: "Auto" };

export const SizeWithAutoJSWithOrder = [
  ...SizeWithJSWithOrder,
  ["auto", "Auto"],
];

export const SizeWithFullJS = { ...SizeJS, full: "Full" };

export const SizeWithFullJSWithOrder = [
  ...SizeWithJSWithOrder,
  ["full", "Full"],
];

export type SizeWithFull = keyof typeof SizeWithFullJS;

export type FontSize = keyof typeof FontSizeJS;

export const FontSizeJS = {
  xs: 12,
  sm: 14,
  base: 16,
  lg: 18,
  xl: 20,
  "2xl": 24,
  "3xl": 30,
  "4xl": 36,
  "5xl": 48,
  "6xl": 60,
  "7xl": 72,
  "8xl": 96,
  "9xl": 128,
};

export enum FontType {
  Sans = "sans",
  Serif = "serif",
  Mono = "mono",
  Display = "display",
}

export const FontFamilyJSWithOrder = [
  {
    family: "Roboto Slab",
    type: FontType.Serif,
  },
  {
    family: "Crimson Text",
    type: FontType.Serif,
  },
  {
    family: "EB Garamond",
    type: FontType.Serif,
  },
  {
    family: "Amiri",
    type: FontType.Serif,
  },
  {
    family: "Neuton",
    type: FontType.Serif,
  },
  {
    family: "Zilla Slab",
    type: FontType.Serif,
  },
  {
    family: "Josefin Slab",
    type: FontType.Serif,
  },
  {
    family: "Unna",
    type: FontType.Serif,
  },
  {
    family: "Abhaya Libre",
    type: FontType.Serif,
  },
  {
    family: "Domine",
    type: FontType.Serif,
  },
  {
    family: "Roboto",
    type: FontType.Sans,
  },
  {
    family: "Ubuntu",
    type: FontType.Sans,
  },
  {
    family: "Rubik",
    type: FontType.Sans,
  },
  {
    family: "Cabin",
    type: FontType.Sans,
  },
  {
    family: "Heebo",
    type: FontType.Sans,
  },
  {
    family: "Notable",
    type: FontType.Sans,
  },
  {
    family: "Barlow",
    type: FontType.Sans,
  },
  {
    family: "Sora",
    type: FontType.Sans,
  },
  {
    family: "Archivo Narrow",
    type: FontType.Sans,
  },
  {
    family: "Asap",
    type: FontType.Sans,
  },
  {
    family: "Ropa Sans",
    type: FontType.Sans,
  },
  {
    family: "Inter",
    type: FontType.Sans,
  },
  {
    family: "IBM Plex Sans",
    type: FontType.Sans,
  },
  {
    family: "DM Sans",
    type: FontType.Sans,
  },
  {
    family: "Roboto Mono",
    type: FontType.Mono,
  },
  {
    family: "Inconsolata",
    type: FontType.Mono,
  },
  {
    family: "Source Code Pro",
    type: FontType.Mono,
  },
  {
    family: "Cousine",
    type: FontType.Mono,
  },
  {
    family: "PT Mono",
    type: FontType.Mono,
  },
  {
    family: "Nanum Gothic Coding",
    type: FontType.Mono,
  },
  {
    family: "Space Mono",
    type: FontType.Mono,
  },
  {
    family: "Anonymous Pro",
    type: FontType.Mono,
  },
  {
    family: "Cutive Mono",
    type: FontType.Mono,
  },
  {
    family: "Oxygen Mono",
    type: FontType.Mono,
  },
  {
    family: "Squada One",
    type: FontType.Display,
  },
  {
    family: "Bahianiata",
    type: FontType.Display,
  },
  {
    family: "Barriecito",
    type: FontType.Display,
  },
  {
    family: "Mountains of Christmas",
    type: FontType.Display,
  },
  {
    family: "Lobster",
    type: FontType.Display,
  },
  {
    family: "Abril Fatface",
    type: FontType.Display,
  },
  {
    family: "Righteous",
    type: FontType.Display,
  },
  {
    family: "Comfortaa",
    type: FontType.Display,
  },
  {
    family: "Geostar",
    type: FontType.Display,
  },
  {
    family: "Patua One",
    type: FontType.Display,
  },
];

export const FontFamilyTypeJS = {
  header: "Header",
  body: "Body",
};

export type FontFamilyType = keyof typeof FontFamilyTypeJS;

export const FontFamilyJSWithOrderDropdownOptions = FontFamilyJSWithOrder.map(
  ({ family, type }) => [family, family, type]
);
export const FontFamilyJS = Object.fromEntries(
  FontFamilyJSWithOrder.map(({ family }) => [family, family])
);

export type FontFamily = keyof typeof FontFamilyJS;

export type FontWeight = keyof typeof FontWeightJS;

export const FontWeightJS = {
  thin: "Thin",
  extralight: "Extra Light",
  light: "Light",
  normal: "Regular",
  medium: "Medium",
  semibold: "Semi Bold",
  bold: "Bold",
  extrabold: "Extra Bold",
  black: "Black",
};

export const LineHeightJSWithOrder = [
  ["none", "None"],
  ["tight", "Tight"],
  ["snug", "Snug"],
  ["normal", "Normal"],
  ["relaxed", "Relaxed"],
  ["loose", "Loose"],
];

export const LineHeightJS = Object.fromEntries(LineHeightJSWithOrder);

export type LineHeight = keyof typeof LineHeightJS;

export type LetterSpacing = keyof typeof LetterSpacingJS;

export const LetterSpacingJS = {
  tighter: "Tighter",
  tight: "Tight",
  normal: "Normal",
  wide: "Wide",
  wider: "Wider",
  widest: "Widest",
};

export type Width = keyof typeof WidthJS;

export const WidthJSWithOrder = [...SizeWithAutoJSWithOrder, ["full", "Full"]];

export const WidthJS = { full: "Full", ...SizeWithAutoJS };

export type WidthWithScreen = keyof typeof WidthWithScreenJS;

export const WidthWithScreenJSWithOrder = [
  ...WidthJSWithOrder,
  ["screen", "Screen"],
];

export const WidthWithScreenJS = { screen: "Screen", ...WidthJS };

export const MaxWidthJSWithOrder = [
  ["xs", "X-Small"],
  ["sm", "Small"],
  ["md", "Medium"],
  ["lg", "Large"],
  ["xl", "X-Large"],
  ["2xl", "2X-Large"],
  ["3xl", "3X-Large"],
  ["4xl", "4X-Large"],
  ["5xl", "5X-Large"],
  ["6xl", "6X-Large"],
  ["7xl", "7X-Large"],
  ["full", "Full"],
];

export const MaxWidthJS = Object.fromEntries(MaxWidthJSWithOrder);

export type MaxWidth = keyof typeof MaxWidthJS;

export const HeightJSWithOrder = [...SizeWithAutoJSWithOrder, ["full", "Full"]];
export const HeightJS = { full: "Full", ...SizeWithAutoJS };

export type Height = keyof typeof HeightJS;

export type Border = {
  style: BorderStyle;
  radius: BorderRadius;
  width: BorderWidth;
  color: ColorMediaShape;
} | null;

export const BorderWidthJSWithOrder = [
  [0, "0"],
  [1, "1"],
  [2, "2"],
  [4, "4"],
  [8, "8"],
];

export const BorderWidthJS = Object.fromEntries(BorderWidthJSWithOrder);

export type BorderWidth = keyof typeof BorderWidthJS;

export const BorderRadiusJSWithOrder = [
  ["none", "None"],
  ["sm", "Small"],
  ["md", "Medium"],
  ["lg", "Large"],
  ["xl", "X-Large"],
  ["2xl", "XX-Large"],
  ["3xl", "XXX-Large"],
  ["full", "Circle"],
];

export const BorderRadiusJS = Object.fromEntries(BorderRadiusJSWithOrder);

export type BorderRadius = keyof typeof BorderRadiusJS;

export const BorderStyleJSWithOrder = [
  ["solid", "Solid"],
  ["dashed", "Dashed"],
  ["dotted", "Dotted"],
  ["double", "Double"],
  ["hidden", "Hidden"],
  ["none", "None"],
];

export const BorderStyleJS = Object.fromEntries(BorderStyleJSWithOrder);

export type BorderStyle = keyof typeof BorderStyleJS | null;

export const TextAlignJSWithOrder = [
  ["left", "Left"],
  ["center", "Center"],
  ["right", "Right"],
  ["justify", "Justify"],
];

export const TextAlignJS = Object.fromEntries(TextAlignJSWithOrder);

export type TextAlign = keyof typeof TextAlignJS;

export type Direction = keyof typeof DirectionJS | null;

export const DirectionJS = {
  row: "Row",
  column: "Column",
};

export type Shadow = keyof typeof ShadowJS | null;

export const ShadowJSWithOrder = [
  ["none", "None"],
  ["sm", "Small"],
  ["base", "Normal"],
  ["md", "Medium"],
  ["lg", "Large"],
  ["xl", "X-Large"],
  ["2xl", "XX-Large"],
];

export const ShadowJS = Object.fromEntries(ShadowJSWithOrder);

export const DirectionRangeJSWithOrder = [
  ["t", "Top"],
  ["tr", "Top Right"],
  ["r", "Right"],
  ["br", "Bottom Right"],
  ["b", "Bottom"],
  ["bl", "Bottom Left"],
  ["l", "Left"],
  ["tl", "Top Left"],
];

export const DirectionRangeJS = Object.fromEntries(DirectionRangeJSWithOrder);

export type DirectionRange = keyof typeof DirectionRangeJS;

export interface Slug {
  name: string;
  slug: string; // derived from name
  default?: boolean; // only one document per website can have default true
}

export interface Contents {
  direction: Direction;
  align: Alignment;
  gap: SizeWithFull;
  wrap: Wrap;
}

export interface NavbarContents {
  direction: Direction;
  align: Alignment;
  gap: SizeWithFull;
  wrap: Wrap;
}

export enum LinkToEnum {
  Page = "page",
  External = "external",
  Spacer = "spacer",
  Icon = "icon",
}

export const LinkToTypeJSWithOrder = [
  [LinkToEnum.Page, "Page"],
  [LinkToEnum.External, "External Link"],
  [LinkToEnum.Spacer, "Spacer"],
  [LinkToEnum.Icon, "Icon"],
];

export interface LinkToBase {
  type: LinkToEnum;
}

export interface LinkToPage extends LinkToBase {
  type: LinkToEnum.Page;
  label: string;
  slugInteractableId: TemplateInteractableLogicProps["interactableId"];
}

export interface LinkToExternal extends LinkToBase {
  type: LinkToEnum.External;
  label: string;
  href: string;
  external: boolean;
}

export interface LinkSpacer extends LinkToBase {
  type: LinkToEnum.Spacer;
}

// Keep icon styling localized to the to payload. TODO: untangle all this eventually
export interface LinkIcon extends LinkToBase {
  type: LinkToEnum.Icon;
  staticClassName: string;
  className: string;
  styles: {
    image: CustomMediaShape | null;
    w: SizeSmall;
  };
}

export type LinkToType = LinkToPage | LinkToExternal | null;

export enum NavbarItemType {
  NavbarItem = "navbar_item",
}

export interface NavbarItem {
  type: NavbarItemType;
  values: {
    to: LinkToType | LinkSpacer | LinkIcon;
  };
  className: string;
  styles: {
    family: FontFamilyType;
    size: FontSize;
    weight: FontWeight;
    lineSpacing: LineHeight;
    letterSpacing: LetterSpacing;
    color: ColorMediaShape;
    pt: SizeWithAuto;
    pr: SizeWithAuto;
    pb: SizeWithAuto;
    pl: SizeWithAuto;
    bg: ColorMediaShape;
    border: Border;
    hover: {
      bg: ColorMediaShape | null;
      color: ColorMediaShape;
    } | null;
  };
}

export interface NavbarItemWithNew extends NavbarItem {
  new: boolean;
}

export const NavbarPositionJS = {
  sticky: "Sticky",
  relative: "Relative",
};

export type NavbarPosition = keyof typeof NavbarPositionJS;

export const MobileResponsivenessJS = {
  auto: "Auto",
  manual: "Manual",
};

export type MobileResponsiveness = keyof typeof MobileResponsivenessJS;

export interface MobilePayload<T extends Component> {
  type: MobileResponsiveness;
  styles: Partial<T["styles"]>;
}

export enum DragBorder {
  Top = "top",
  Right = "Right",
  Bottom = "Bottom",
  Left = "Left",
  Inner = "Inner",
}
